import { SceneRenderer } from "./SceneRenderer";
import { Scene } from "../Scene";
import { Camera } from "../View";
import { Context } from "../Engine";
import { Overlay } from "../Object/Overlay";
import { RenderMode } from "../Object/ObjectManager";

export class OverlaySceneRenderer extends SceneRenderer {
    private ctx: Context;
    public overlay: Overlay;

    public init(ctx: Context) {
        this.ctx = ctx;
    }

    public destroy(): void {

    }

    public render(scene: Scene, camera: Camera, buffer: WebGLFramebuffer): void {
        let ctx = this.ctx;
        let gl = this.ctx.gl;

        gl.bindFramebuffer(gl.FRAMEBUFFER, buffer);

        gl.viewport(0, 0, this.ctx.viewPort.width, this.ctx.viewPort.height);
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);


        //scene.objectManager.iterate(RenderMode.Primary, obj => obj.render(ctx, camera, { mode: RenderMode.Primary }));
        
        this.overlay.render(ctx, camera, { mode: RenderMode.Primary });
    }

}